import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import FaqComponent from "../FaqComponent";
import RightSideForm from "./../RightSideForm";


export default function GetInTouch() {
  const navigate = useNavigate();
  const location = useLocation();

  // Map of page-specific FAQs
  const faqMap = {
    "/ear-clinic-delhi": [
      {
        question: "What are common ear conditions treated at your clinic?",
        answer: " We treat ear infections, hearing loss, tinnitus, earwax buildup, perforated eardrum, and balance disorders."
        
      },
      {
        question: "Do you perform ear surgeries?",
        answer: " Yes. Surgeries like tympanoplasty, mastoidectomy, and stapedectomy are performed for chronic ear issues and hearing restoration."
      },
      {
        question: "Can hearing loss be reversed?",
        answer: " Some types of hearing loss, especially conductive ones, can be treated medically or surgically. Sensorineural loss may need hearing aids or cochlear implants."
      },
      {
        question: "Do you offer hearing tests at the clinic?",
        answer: " Yes, we provide complete audiometry and impedance testing on-site."
      }, {
        question: "Is tinnitus (ringing in ears) treatable?",
        answer: " While tinnitus may not always be curable, we offer treatments that reduce symptoms, including sound therapy, counseling, and medication"
      }
    ],
    "/nose-surgery-cost-delhi": [
      {
        question: "What nasal problems do you treat?",
        answer: " We manage sinusitis, nasal polyps, deviated nasal septum (DNS), nosebleeds, allergies, and nasal obstruction."
      },
      {
        question: "Do you perform septoplasty for a deviated septum?",
        answer: " Yes, septoplasty is a common procedure to correct DNS and improve breathing."
      },
      {
        question: "What are nasal polyps and how are they treated?",
        answer: "  Nasal polyps are soft growths inside the nose that cause blockage. We treat them with medication or endoscopic surgery if needed."
      },
      {
        question: "Can sinusitis be permanently cured?",
        answer: "  Yes. Acute sinusitis is treatable with medication; chronic cases may require endoscopic sinus surgery (FESS)."
      },
      {
        question: "Do you offer allergy testing for nasal problems?",
        answer: " Yes, we offer allergy evaluation and treatment including antihistamines and immunotherapy if needed."
      }
    ],
    "/throat-doctor-delhi": [
      {
        question: "What throat issues do you treat?",
        answer: " We treat sore throat, tonsillitis, voice hoarseness, swallowing difficulties, and acid reflux-related throat irritation."
      },
      {
        question: "Do you perform tonsil and adenoid removal?",
        answer: "Yes. Tonsillectomy and adenoidectomy are common surgeries for chronic infections or breathing issues in children."
      },
      {
        question: "How are voice problems diagnosed?",
        answer: " We use laryngoscopy and voice assessment tools to diagnose vocal cord issues and recommend therapy or surgery if needed."
      },
      {
        question: "Is snoring a serious problem?",
        answer: " Snoring can indicate sleep apnea, which is a serious condition. We offer diagnosis and treatment plans tailored to the root cause."
      },
      {
        question: "Can throat cancer be detected early?",
        answer: " Yes, regular laryngoscopy and biopsy help detect early signs of cancer in chronic smokers or patients with persistent voice changes."
      },
    ],
    "/endoscopy": [
      {
        question: "What is nasal endoscopy?",
        answer: "I It’s a simple procedure using a thin camera to examine the nasal passages, sinuses, and throat for accurate diagnosis"
      },
      {
        question: "Is endoscopy painful?",
        answer: "Not at all. It’s usually done under local anesthesia and takes just a few minutes."
      },
      {
        question: "Why is nasal endoscopy done?",
        answer: " It helps detect nasal polyps, tumors, chronic sinusitis, and sources of bleeding or blockage."
      },
      {
        question: "Is endoscopy only for diagnosis?",
        answer: " No. Endoscopy is also used during minimally invasive surgeries like FESS and biopsy procedures."
      },
      {
        question: "How should I prepare for ENT endoscopy?",
        answer: "No special preparation is needed. Just inform the doctor of any nasal sprays or bleeding history before the procedure."
      }
    ],
    "/ent-surgery": [
      {
        question: "What types of ENT surgeries are performed?",
        answer: " We perform surgeries for ear infections, nasal blockage, throat problems, snoring, vertigo, and tumors of the head and neck."
      },
      {
        question: "Is general anesthesia used in ENT surgery?",
        answer: " Yes, depending on the procedure. Minor ones are done under local anesthesia; complex surgeries require general anesthesia."
      }, {
        question: "What is FESS (Functional Endoscopic Sinus Surgery)?",
        answer: "FESS is a modern, scarless surgery used to treat chronic sinusitis and nasal polyps with minimal downtime."
      },
      {
        question: "How long does recovery take after ENT surgery?",
        answer: " Most patients recover within 5–10 days. Full healing depends on the type of surgery and patient health"
      },
      {
        question: "Are ENT surgeries safe?",
        answer: "Yes. All procedures are done with advanced equipment, under sterile conditions, and by experienced ENT surgeons."
      },
    ]
  };

  const path = location.pathname.replace(/\/$/, ""); // remove trailing slash if any
  const contactFaq = faqMap[path] || [];

  const [formDataState, setFormDataState] = useState({
    name: "",
    email: "",
    phone: "",
    findUs: "",
    message: ""
  });

  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataState((prev) => ({ ...prev, [name]: value }));
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    if (formDataState.phone.length !== 10) {
      alert("Please enter a valid 10-digit phone number");
      return;
    }

    setIsSubmitting(true);

    const formData = new FormData();
    Object.entries(formDataState).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      const response = await axios.post("https://entdelhi.com/mailer/mailer.php", formData);

      if (response.data.success) {
        setStatus("Message sent successfully!");
        setFormDataState({ name: "", email: "", phone: "", findUs: "", message: "" });
        navigate("/thank-you");
      } else {
        setStatus("Failed to send message.");
        console.error(response.data.error);
      }
    } catch (error) {
      setStatus("Something went wrong!");
      console.error("Axios error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
          {contactFaq.length > 0 && (
      <FaqComponent faqData={contactFaq} sectionTitle="Frequently Asked Questions" />
    )}


      <section className="get-in-touch">
        <div className="container">
          <div className="pq-bg-white pq-form-bg-white p-4">
            <div className="row align-items-center">
              <div className="col-xl-6 ps-xl-4 mt-4 mt-xl-0 pq-p-45">
                <div className="pq-section pq-style-1 text-left">
                  <h2 className="pq-section-title">Contact Us </h2>

                  <div className="pq-section pq-style-1 text-left">
                  <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.1814325306223!2d77.15069767613537!3d28.564314087174107!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1dac3cbaeea1%3A0xda530ec64e7913b3!2sDr%20Rajesh%20Bhardwaj%20-%20Best%20ENT%20Clinic!5e0!3m2!1sen!2sin!4v1741353822175!5m2!1sen!2sin"
                      width="100%"
                      height="300"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Google Maps"
                    ></iframe>
                  </div>
                </div>
              </div>

              <div className="col-xl-6 ps-xl-4 mt-4 mt-xl-0 pq-p-45">
               




                  <RightSideForm />


              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
